module.exports = __webpack_public_path__ + "img/contractor.53b0ec22.svg";